import { createSelector } from 'reselect';
import { getActiveSpaceId } from 'spaces/store/selectors';
import { getRolesById } from '../roles/selectors';

export const getAuditPendingRoleIdsBySpaceId = (state) => state.audit.pendingRoleIdsBySpaceId;

export const getActiveStateAuditPendingRoleIds = createSelector(
  [getActiveSpaceId, getAuditPendingRoleIdsBySpaceId],
  (spaceId, ids) => (ids[spaceId] ? ids[spaceId] : []),
);

export const getActiveStateAuditPendingRoles = createSelector(
  [getActiveStateAuditPendingRoleIds, getRolesById],
  (ids, rolesById) => (ids.length > 0 ? ids.map((id) => rolesById[id]) : []),
);
